export const PRICING_PLANS = ["Interchange Plus", "Differential", "Surcharge"];

export function optionsFor(proc: string, plan: string): string[] {
  if (plan === "Interchange Plus") return ["Interchange Plus Pass Thru Plus Non-qualified"];
  if (plan === "Differential") return ["Base rate Differential Plus Surcharge"];
  if (plan === "Surcharge") {
    if (proc === "MOTO") return ["Base rate Surcharge (Non)"];
    return [
      "Base rate Surcharge (Mid/Non w/ Pass Thru Qualified Rewards and Rebates)",
      "Base rate Surcharge (Mid/Non)",
    ];
  }
  return [];
}

export type BaseRateLine = { pctKey: string; perItemKey?: string; label: string; required: boolean };

export function baseRateLinesFor(proc: string, plan: string, option: string): BaseRateLine[] {
  const lines: BaseRateLine[] = [
    { pctKey: "baseRatePct", perItemKey: "baseRatePerItem", label: "All Card Types", required: true },
  ];
  if (plan === "Differential") {
    lines.push({ pctKey: "differentialPct", perItemKey: "differentialPerItem", label: "Differential +", required: true });
  } else if (plan === "Interchange Plus") {
    lines.push({ pctKey: "plusNonQualPct", label: "Plus Non Qualified Processing Fee", required: true });
  } else if (plan === "Surcharge") {
    if (option.includes("Pass Thru Qualified Rewards and Rebates")) {
      lines.push({ pctKey: "checkCardRebatePct", perItemKey: "checkCardRebatePerItem", label: "Check Card Rebate", required: true });
    }
    if (proc === "MOTO") {
      lines.push({ pctKey: "nonQualPct", perItemKey: "nonQualPerItem", label: "Non Qual", required: true });
    } else {
      lines.push({ pctKey: "midQualPct", perItemKey: "midQualPerItem", label: "Mid Qual", required: true });
      lines.push({ pctKey: "nonQualPct", perItemKey: "nonQualPerItem", label: "Non Qual", required: true });
    }
  }
  return lines;
}

export const AWAITING_AGENT_PRICING = "AwaitingAgentPricing";

export const PRICING_PROGRAMS = [
  "Dual Pricing", "Cash Discount 1.0", "Cash Discount 2.0", "Interchange Plus", "Flat Rate", "Surcharge",
] as const;

export const PRICING_RATE_FLOORS: Record<string, number> = {
  "Dual Pricing": 3,
  "Cash Discount 1.0": 3,
  "Cash Discount 2.0": 3,
  "Flat Rate": 2.5,
  "Surcharge": 2.75,
  "Interchange Plus": 0.1,
};

export const IC_PER_TXN_FLOOR = 0.1;

export const ONLINE_ORDERING_SEPARATE_BELOW = 3.5;
const ONLINE_ORDERING_SEPARATE_PROGRAMS = new Set(["Dual Pricing", "Cash Discount 1.0", "Cash Discount 2.0", "Flat Rate", "Surcharge"]);

export function onlineOrderingNeedsSecondApp(program: unknown, rate: unknown): boolean {
  if (program === "Interchange Plus") return true;
  const value = typeof rate === "number" ? rate : typeof rate === "string" && rate.trim() !== "" ? Number(rate) : NaN;
  return typeof program === "string" && ONLINE_ORDERING_SEPARATE_PROGRAMS.has(program)
    && Number.isFinite(value) && value < ONLINE_ORDERING_SEPARATE_BELOW;
}

export const AMEX_NOT_HIGHER_MESSAGE = "American Express rate must be higher than the program rate.";
